const { fetchJsonApi } = require('./abstract');
const { getApiLanguage } = require('./language');

const ENGAGEMENT = 'engagement';
const RECENT = 'recent';
const VIRAL = 'viral';

function fetchNewsFeed(apiUrl, { from, limit, sort = ENGAGEMENT } = {}) {
  return fetchJsonApi({
    apiUrl,
    method: 'GET',
    endpoint: 'v1/news-feed',
    query: {
      from,
      limit,
      sort,
      lang: getApiLanguage(),
    },
    expectedStatus: 200,
    description: 'Fetching news feed',
  });
}

module.exports = {
  fetchNewsFeed,
  ENGAGEMENT,
  RECENT,
  VIRAL,
};
